/* eslint-disable no-console */

type LogLevel = 'info' | 'warn' | 'error' | 'debug';

/**
 * 로그 레벨에 맞는 콘솔 메서드 반환
 */
function getConsoleMethod(level: LogLevel): typeof console.log {
  switch (level) {
    case 'error':
      return console.error;
    case 'warn':
      return console.warn;
    case 'debug':
      return console.debug;
    default:
      return console.log;
  }
}

/**
 * 범용 로깅 함수
 * - Vercel 로그에서 확인 가능
 * - 카테고리와 데이터를 구조화된 형태로 출력
 */
function log(level: LogLevel, category: string, message: string, data?: Record<string, unknown>) {
  const consoleMethod = getConsoleMethod(level);
  const timestamp = new Date().toISOString();

  if (data && Object.keys(data).length > 0) {
    consoleMethod(`[${timestamp}] [${category.toUpperCase()}] ${message}`, data);
  } else {
    consoleMethod(`[${timestamp}] [${category.toUpperCase()}] ${message}`);
  }
}

/**
 * 간편한 로깅 헬퍼 함수들
 * Vercel 로그에서 확인 가능 (Sentry의 logger와 구분하기 위해 dbLogger로 명명 유지)
 */
export const dbLogger = {
  info: (category: string, message: string, data?: Record<string, unknown>) =>
    log('info', category, message, data),

  warn: (category: string, message: string, data?: Record<string, unknown>) =>
    log('warn', category, message, data),

  error: (category: string, message: string, data?: Record<string, unknown>) =>
    log('error', category, message, data),

  debug: (category: string, message: string, data?: Record<string, unknown>) =>
    log('debug', category, message, data),
};
